export * from "../overrides/modal";

// soon to be depricated.
import { Modal } from "../overrides/modal";

const modalInit = el => {
  return new Modal(el);
};

window.orbit = window.orbit || {};
window.orbit.modal = modalInit;

export default Modal;
